import CatalogLayout from '@/layouts/CatalogLayout.vue'

export const PRODUCT_ROUTES = [
  {
    path: 'catalog/manufacturers/create',
    name: 'CreateManufacturer',
    component: () => import('./manufacturers/views/CreateManufacturer.vue'),
  },
  {
    path: 'catalog/manufacturers/:id/edit',
    name: 'EditManufacturer',
    component: () => import('./manufacturers/views/EditManufacturer.vue'),
  },
  {
    path: 'catalog/categories/create',
    name: 'CreateCategory',
    component: () => import('./categories/views/CreateCategory.vue'),
  },
  {
    path: 'catalog/categories/:id/edit',
    name: 'EditCategory',
    component: () => import('./categories/views/EditCategory.vue'),
  },
  {
    path: 'catalog/products/create',
    name: 'CreateProduct',
    component: () => import('./products/views/CreateProduct.vue'),
  },
  {
    path: 'catalog/products/:id/edit',
    name: 'EditProduct',
    component: () => import('./products/views/EditProduct.vue'),
  },
  {
    path: 'catalog',
    component: CatalogLayout,
    redirect: { name: 'ProductList' },
    children: [
      {
        path: 'products',
        name: 'ProductList',
        component: () => import('./products/views/ProductList.vue'),
      },
      {
        path: 'manufacturers',
        name: 'ManufacturerList',
        component: () => import('./manufacturers/views/ManufacturerList.vue'),
      },
      {
        path: 'categories',
        name: 'CategoryList',
        component: () => import('./categories/views/CategoryList.vue'),
      },
    ],
  },
]
